import { ns } from 'solid-ui';
import { NamedNode, sym } from 'rdflib';
/**
 * Constructs an attribution object for the node the subject is attributed to.
 */
export function readAttribution(subject, store) {
    const attributedTo = store.any(subject, ns.as('attributedTo'));
    return read(attributedTo, store);
}
function containsPersonType(types) {
    const as = ns.as('Person').uri;
    const foaf = ns.foaf('Person').uri;
    const vcard = ns.vcard('Individual').uri;
    const schema = ns.schema('Person').uri;
    return types[as] || types[foaf] || types[vcard] || types[schema];
}
/**
 * Constructs an attribution object for the given node with data read from the store
 */
function read(attributedTo, store) {
    if (attributedTo instanceof NamedNode) {
        const types = store.findTypeURIs(attributedTo);
        if (containsPersonType(types)) {
            return readPerson(store, attributedTo);
        }
        else {
            return {
                discriminator: 'LinkAttribution',
                uri: attributedTo.uri,
            };
        }
    }
    return {
        discriminator: 'NoAttribution',
    };
}
function readPerson(store, attributedTo) {
    const name = store.anyValue(attributedTo, ns.as('name')) ||
        store.anyValue(attributedTo, ns.foaf('name')) ||
        store.anyValue(attributedTo, ns.vcard('fn')) ||
        store.anyValue(attributedTo, ns.schema('name')) ||
        '';
    const imageSrc = readImageSrc(store, attributedTo);
    return {
        discriminator: 'PersonAttribution',
        webId: attributedTo.uri,
        name,
        imageSrc,
    };
}
function readImageSrc(store, attributedTo) {
    const image = store.anyValue(attributedTo, ns.as('image'));
    if (image) {
        return store.anyValue(sym(image), ns.as('url')) || undefined;
    }
    return (store.anyValue(attributedTo, ns.foaf('img')) ||
        store.anyValue(attributedTo, ns.vcard('hasPhoto')) ||
        undefined);
}
/**
 * Fetches the given attribution uri and returns an updated attribution with data from the fetched resource
 */
export async function fetchAttribution(attribution, store) {
    const attributionNode = sym(attribution.uri);
    await store.fetcher.load(attributionNode);
    return read(attributionNode, store);
}
//# sourceMappingURL=attribution.js.map